import React, { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import '../styles/OrderSuccess.css';

const OrderSuccess = () => {
  const [searchParams] = useSearchParams();
  const { clearCart } = useCart();
  const orderId = searchParams.get('orderId') || searchParams.get('transactionId');

  useEffect(() => {
    // Clear cart upon successful checkout
    if (clearCart) {
      clearCart();
    }
    window.scrollTo(0, 0);
  }, [clearCart]);

  return (
    <section className="order-success-page">
      <div className="order-success-container">
        <div className="order-success-icon-wrapper">
          ✓
        </div>

        <h1>Thank you for Your Order!</h1>
        {orderId && (
          <p style={{
            display: 'inline-block',
            background: '#f3f4f6',
            color: '#4b5563',
            fontSize: '0.85rem',
            padding: '4px 12px',
            borderRadius: '12px',
            marginBottom: '16px'
          }}>
            Order Ref: <strong>{orderId}</strong>
          </p>
        )}
        <p className="order-success-subtitle">
          Your payment was processed successfully through Square. We have received your order and custom specifications!
        </p>

        <div className="order-details-card">
          <h3>📦 What Happens Next?</h3>
          <ul>
            <li>
              <span className="bullet">✦</span>
              <span><strong>Receipt & Confirmation:</strong> Square has sent a detailed payment receipt directly to the email/phone you entered during checkout.</span>
            </li>
            <li>
              <span className="bullet">✦</span>
              <span><strong>Handcrafting Your Items:</strong> Each collage, photocard, and sanitizer is carefully handmade in Hawaii with love. Current processing time is typically 3–7 business days.</span>
            </li>
            <li>
              <span className="bullet">✦</span>
              <span><strong>Shipping:</strong> Standard orders ship via USPS stamped or tracked mail from Hawaii. You will receive an update once it is on its way.</span>
            </li>
          </ul>
        </div>

        <div className="order-success-actions">
          <Link to="/shop" className="shop-more-btn">
            Continue Exploring
          </Link>
          <Link to="/" style={{ color: '#4b5563', fontSize: '0.9rem', textDecoration: 'none' }}>
            Back to Homepage
          </Link>
        </div>

        <p className="support-note">
          Have questions about your order or custom requests? DM us on Instagram{' '}
          <a href="https://instagram.com/star.ryhwa" target="_blank" rel="noopener noreferrer">@star.ryhwa</a>{' '}
          or email <a href="mailto:officialstar.ryhwa@gmail.com">officialstar.ryhwa@gmail.com</a>.
        </p>
      </div>
    </section>
  );
};

export default OrderSuccess;
